// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3cq31","rootCenter":"LoadMoreObserver_rootCenter__3DPCg","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3rWr7"};